import * as React from "react";
import {PageTitle} from "../../components/TitleBar/PageTitle";
import {faDashboard} from "@fortawesome/free-solid-svg-icons";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import RefinitivStats from "../../components/Refinitiv/Stats/RefinitivStats";
import Typography from "@mui/material/Typography";
import RefinitivTable from "../../components/Refinitiv/Table/RefinitivTable";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import {useIsRefinitiv} from "../../hooks/refinitiv";


export const DashboardContainer = ({}) => {
    const [favDisplay, setFavDisplay] = React.useState("deliveries")
    const isRefinitiv = useIsRefinitiv();

    const handleFavChange = (
        event: React.MouseEvent<HTMLElement>,
        newFavDisplay: string,
    ) => {
        if (newFavDisplay) {
            setFavDisplay(newFavDisplay);
        }
    };

    return (
        <Box>
            <PageTitle pageTitle="Dashboard" icon={faDashboard}/>
            {
                isRefinitiv && <RefinitivStats/>
            }
            <Grid container columnSpacing={2}>
                <Grid item xs={12}>
                    {
                        isRefinitiv && (
                            <React.Fragment>
                                <Box sx={{display: 'flex', justifyContent: 'space-between', mb: 3, mt: 3}}>
                                    <Typography variant="h5">
                                        Favorites
                                    </Typography>
                                    <ToggleButtonGroup
                                        color="primary"
                                        value={favDisplay}
                                        exclusive
                                        onChange={handleFavChange}
                                        aria-label="Platform"
                                        size="small"
                                    >
                                        <ToggleButton value="deliveries">Deliveries</ToggleButton>
                                        <ToggleButton value="collections">Collections</ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>

                                {
                                    favDisplay === "collections" && (
                                        <RefinitivTable
                                            key="favCollections"
                                            mode="collectionStatuses"
                                            favoritesOnly={true}
                                        />
                                    )
                                }

                                {
                                    favDisplay === "deliveries" && (
                                        <RefinitivTable
                                            key="favRecentDeliveries"
                                            mode="recentDeliveries"
                                            favoritesOnly={true}
                                        />
                                    )
                                }


                            </React.Fragment>

                        )
                    }
                    {
                        // !isRefinitiv && (
                        //     <EnhancedTable
                        //         title="Reports"
                        //         formatMethod={formatTableData}
                        //         selector={allReportsListSelector}
                        //         selectable={false}
                        //         headers={listHeaders}/>
                        // )
                    }

                </Grid>
            </Grid>

        </Box>
    )
}